import React from "react";
import Helmet from "react-helmet";
import SEO from "../components/SEO";
import "../assets/css/App.css";
import "../assets/css/index.css";
import Layout from "../components/Layout";
import { Jumbotronv2 } from "../components/Jumbotronv2";
import { Link } from "gatsby";
import ContactForm from "../components/ContactForm";
import { Video } from "../components/Video";
import { Row, Col, Button } from "react-bootstrap";



export default ({ data }) => (
  <Layout>
    <SEO
      title="Property & Block Management Case Study | Queens Court, Bayswater | BBIS Heating"
      description="BBIS Heating renewed and rationalised the boiler plant at Queens Court, Bayswater - a 337-flat estate in West London - delivering a centralised, efficient heating and hot water system."
      keywords="Queens Court Bayswater heating, boiler plant renovation, communal heating upgrade, BBIS Heating case study, residential estate heating, centralised heating system, gas turbine meter installation, asbestos removal heating project"
    />
    <div className="white-segment">
            <Row className="pb-3">
        <Video></Video>
      </Row>
    <h1 className="heading-color">Property & Block Management Case Study: Queens Court, Bayswater</h1>
    <p><strong>Comprehensive boiler plant room renovation for a 337-apartment estate in West London</strong></p>
      <p>
        With decades of experience delivering complex heating projects for residential and commercial clients, <strong>BBIS Commercial Heating</strong> was appointed to design and install a new, efficient boiler plant system for Queens Court in Bayswater. The large estate, comprising <strong>337 flats</strong> across three blocks, required a complete overhaul of its heating and hot water infrastructure to replace outdated equipment and improve reliability for residents.
      </p>
    </div>

    <div className="grey-segment">
      <h2 className="heading-color">Project overview</h2>
      <p>
        The project involved the renewal and rationalisation of three independent boiler plant rooms that served the estate. The existing systems were in a state of considerable disrepair and were no longer suitable for modern condensing boiler combustion. The boiler plants also provided domestic hot water for the entire development, adding further complexity to the upgrade.
      </p>

      <h2 className="heading-color">Initial consultation and planning</h2>
      <p>
        Recognising the scale of the challenge, we advised that the works required careful planning from the outset. We collaborated closely with consulting engineers to develop a coordinated and technically robust scheme. This partnership ensured that every aspect of the design met both performance and compliance standards while future-proofing the system for years to come.
      </p>

      <h2 className="heading-color">Designing a centralised heating solution</h2>
      <p>
        During the design phase, it was agreed that the three existing boiler plants would be combined into a single, centralised system. This new configuration would deliver primary heating to each block, supported by individual heat meters to accurately monitor and manage consumption.
      </p>
      <p>
        This rationalised approach offered significant benefits, including improved energy efficiency, simplified maintenance, and reduced operational costs for the <Link to="/property-block-management-heating-services">estate management team</Link>.
      </p>
      </div>
          <div className="white-segment">

      <h2 className="heading-color">Overcoming on-site challenges</h2>
      <p>
        The existing plantrooms presented several serious challenges. Asbestos was identified across the boiler rooms, requiring specialist removal before works could safely proceed. The installation of modern condensing boilers also demanded a complete redesign of the flue systems to ensure safe and efficient operation.
      </p>
      <p>
        To maintain essential heating and hot water services throughout the works, we installed a temporary boiler plant in the adjacent car park. This ensured residents experienced minimal disruption during the year-long project.
      </p>

      <h2 className="heading-color">Delivering a safer, more efficient heating system</h2>
      <p>
        As part of the rationalisation, we consolidated three independent gas services into a single, new gas supply fitted with a turbine meter to support the new plant.
      </p>
      <p>
        The result is a fully modernised central heating and hot water system that delivers improved efficiency, reliability and safety across all 337 apartments.
      </p>
      <p>
        The Queens Court project demonstrates BBIS Heating’s capability to deliver technically demanding heating solutions for large residential estates, from design and coordination through to installation and commissioning. To view what the completed commercial heating solution looked like, click the 360 virtual tour button below.
      </p>
    <Button
            href="https://hdvirtualart.com/tours/bbis/004/"
            class="primary"
            size="lg"
            target="_blank"
            >
            View 360 tour
        </Button>
    </div>

    <div className="grey-segment">
      <h3 className="heading-color">Is your property management company looking for a new commercial heating partner?</h3>
      <p>
        BBIS Heating is already trusted by a wide range of property management companies across London, Hertfordshire and the surrounding areas.
      </p>
      <p>
        With decades of experience supporting property managers, landlords and housing providers, BBIS Heating is here to help.
      </p>
      <ContactForm />
    </div>
  </Layout>
);
